import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import canteiroAreiaService, { CanteiroAreiaItem, CanteiroAreiaListResponse } from '../../../../services/sementes/canteiroAreia';
import useTetrazolioFilters from './useTetrazolioFilters';
import useTetrazolioOrder from './useTetrazolioOrder';
import { selectTopBarState } from '../../../../components/Topbar/topBarSlice';

export interface CanteiroAreiaHookData {
  data: CanteiroAreiaItem[];
  loading: boolean;
  error: string | null;
  meta: CanteiroAreiaListResponse['meta'] | null;
  refetch: () => void;

  formik: any;
  clearFilters: () => void;
  changePage: (page: number) => void;

  selectedOrder: any;
  changeOrder: (option: any) => void;
}

export default function useCanteiroAreia(): CanteiroAreiaHookData {
  const [data, setData] = useState<CanteiroAreiaItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [meta, setMeta] = useState<CanteiroAreiaListResponse['meta'] | null>(null);

  const { currentProdutor } = useSelector(selectTopBarState);
  const filtersHook = useTetrazolioFilters('ca');
  const orderHook = useTetrazolioOrder('ca');

  const fetchData = useCallback(async () => {
    if (!currentProdutor?.id) {
      setData([]);
      setMeta(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const params = filtersHook.getFiltersFromURL();
      const response = await canteiroAreiaService.list({
        ...params,
        produtorId: currentProdutor.id,
      });

      setData(response.data);
      setMeta(response.meta);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar dados');
      setData([]);
      setMeta(null);
    } finally {
      setLoading(false);
    }
  }, [filtersHook.getFiltersFromURL, currentProdutor?.id]);

  const refetch = useCallback(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    meta,
    refetch,
    formik: filtersHook.formik,
    clearFilters: filtersHook.clearFilters,
    changePage: filtersHook.changePage,
    selectedOrder: orderHook.selectedOrder,
    changeOrder: orderHook.changeOrder,
  };
}
